













 























const node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "updateDragLocation",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateDragLocationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateDragLocationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "m__dabmuhzN90smEZKtveP6Q",
    "metadata": {},
    "name": "UpdateDragLocationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "1edff4026425b6726fe1314e90c140dc";

export default node;
